export default __webpack_public_path__ + "static/media/svg-2.627a8a42.svg";